module.exports = __webpack_public_path__ + "static/media/cubefit_animated.3637ce98.gif";